module.exports = __webpack_public_path__ + "img/20210613_192151.3bf5828c.jpg";